(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-wallpaper-configurator"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-cwc-root]');
    if (!root || root.dataset.booted === '1') return;
    root.dataset.booted = '1';

    var widthInput = document.getElementById('cwc-w');
    var heightInput = document.getElementById('cwc-h');
    var dropZone = document.getElementById('cwc-drop');
    var fileInput = document.getElementById('cwc-file');
    var canvas = document.getElementById('cwc-canvas');
    var unitPriceCents = parseInt(root.dataset.unitPriceCents, 10) || 2600;
    var pricePerSquareMeterCents = unitPriceCents * 10;
    var currencyCode = root.dataset.currencyCode || 'SEK';
    var areaVariantId = root.dataset.areaVariantId || '';
    var panX = 0;
    var panY = 0;
    var dragging = false;
    var dragStartX = 0;
    var dragStartY = 0;
    var panStartX = 0;
    var panStartY = 0;

    window.cwcL = true;
    window.cwcG = false;
    window.cwcF = false;
    window.cwcImg = null;
    window.PRICE = pricePerSquareMeterCents / 100;

    function formatMoney(cents) {
      var wholeAmount = cents / 100;
      var hasDecimals = Math.round(cents) % 100 !== 0;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'sv-SE', {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: hasDecimals ? 2 : 0,
          maximumFractionDigits: hasDecimals ? 2 : 0
        }).format(wholeAmount);
      } catch (error) {
        return wholeAmount.toLocaleString('sv-SE') + ' ' + currencyCode;
      }
    }

    function cwcDims() {
      var width = parseFloat(String(widthInput.value).replace(',', '.')) || 0;
      var height = parseFloat(String(heightInput.value).replace(',', '.')) || 0;
      return {w: width, h: height, valid: width >= 50 && height >= 50};
    }

    function pricing(dimensions) {
      var measuredArea = dimensions.valid ? (dimensions.w / 100) * (dimensions.h / 100) : 0;
      var units = dimensions.valid ? Math.ceil((measuredArea * 10) - 0.000000001) : 0;
      return {
        measuredArea: measuredArea,
        units: units,
        billedArea: units / 10,
        totalCents: units * unitPriceCents
      };
    }

    function cwcUpdateAtc() {
      var button = document.getElementById('cwc-atc');
      button.disabled = !(cwcDims().valid && window.cwcImg && areaVariantId);
    }

    function cwcU() {
      var dimensions = cwcDims();
      var currentPricing = pricing(dimensions);
      var total = dimensions.valid ? formatMoney(currentPricing.totalCents) : '–';
      document.getElementById('cdim').textContent = dimensions.valid
        ? (dimensions.w / 100).toFixed(2) + ' × ' + (dimensions.h / 100).toFixed(2) + ' m'
        : '– × – m';
      document.getElementById('csqm').textContent = dimensions.valid
        ? currentPricing.measuredArea.toFixed(2) + ' m²'
        : '– m²';
      document.getElementById('cwc-billed').textContent = dimensions.valid
        ? currentPricing.billedArea.toFixed(1) + ' m²'
        : '– m²';
      document.getElementById('cwc-price-per-sqm').textContent = formatMoney(pricePerSquareMeterCents) + '/m²';
      document.getElementById('cprice').textContent = total;
      document.getElementById('cbtnp').textContent = total;
      cwcUpdateAtc();
      if (window.cwcImg) cwcDraw();
    }

    function setToggle(button, active) {
      button.classList.toggle('on', active);
      button.setAttribute('aria-pressed', String(active));
    }

    function cwcTog(key, button) {
      if (key === 'lines') window.cwcL = !window.cwcL;
      if (key === 'gray') window.cwcG = !window.cwcG;
      setToggle(button, key === 'lines' ? window.cwcL : window.cwcG);
      if (window.cwcImg) cwcDraw();
    }

    function cwcFlip() {
      window.cwcF = !window.cwcF;
      setToggle(document.getElementById('bt-fl'), window.cwcF);
      if (window.cwcImg) cwcDraw();
    }

    function useFile(file) {
      if (!file || !file.type.startsWith('image/')) {
        window.alert(root.dataset.invalidFile);
        return;
      }
      var reader = new FileReader();
      reader.onload = function (event) {
        var image = new Image();
        image.onload = function () {
          window.cwcImg = image;
          panX = 0;
          panY = 0;
          document.getElementById('cwc-ph').style.display = 'none';
          canvas.style.display = 'block';
          document.getElementById('cuplbl').textContent = file.name;
          document.getElementById('cuplbl-help').textContent = root.dataset.imageChange;
          document.getElementById('cdraghint').classList.add('show');
          cwcSetupPan();
          cwcUpdateAtc();
          cwcDraw();
        };
        image.src = event.target.result;
      };
      reader.readAsDataURL(file);
    }

    function cwcLoad(event) {
      useFile(event.target.files && event.target.files[0]);
    }

    function cwcDraw() {
      var dimensions = cwcDims();
      var width = dimensions.w || 300;
      var height = dimensions.h || 220;
      var area = document.getElementById('cwc-canvas-area');
      var availableWidth = area.clientWidth - 40;
      var availableHeight = area.clientHeight - 40;
      if (availableWidth <= 0 || availableHeight <= 0) {
        window.requestAnimationFrame(cwcDraw);
        return;
      }

      var wallRatio = width / height;
      var areaRatio = availableWidth / availableHeight;
      var canvasWidth;
      var canvasHeight;
      if (wallRatio > areaRatio) {
        canvasWidth = availableWidth;
        canvasHeight = Math.round(availableWidth / wallRatio);
      } else {
        canvasHeight = availableHeight;
        canvasWidth = Math.round(availableHeight * wallRatio);
      }

      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      canvas.style.width = canvasWidth + 'px';
      canvas.style.height = canvasHeight + 'px';
      canvas.style.display = 'block';

      var context = canvas.getContext('2d');
      context.clearRect(0, 0, canvasWidth, canvasHeight);
      context.save();
      if (window.cwcF) {
        context.translate(canvasWidth, 0);
        context.scale(-1, 1);
      }
      if (window.cwcG) context.filter = 'grayscale(1)';

      var scale = Math.max(canvasWidth / window.cwcImg.width, canvasHeight / window.cwcImg.height);
      var drawWidth = window.cwcImg.width * scale;
      var drawHeight = window.cwcImg.height * scale;
      var maxPanX = Math.max(0, (drawWidth - canvasWidth) / 2);
      var maxPanY = Math.max(0, (drawHeight - canvasHeight) / 2);
      panX = Math.max(-maxPanX, Math.min(maxPanX, panX));
      panY = Math.max(-maxPanY, Math.min(maxPanY, panY));
      var drawX = (canvasWidth - drawWidth) / 2 + panX;
      var drawY = (canvasHeight - drawHeight) / 2 + panY;

      context.fillStyle = '#eee';
      context.fillRect(0, 0, canvasWidth, canvasHeight);
      context.drawImage(window.cwcImg, drawX, drawY, drawWidth, drawHeight);
      context.restore();

      if (window.cwcL) {
        var scaleToCentimeters = canvasWidth / width;
        var panelStep = 50 * scaleToCentimeters;
        for (var x = panelStep; x < canvasWidth; x += panelStep) {
          context.setLineDash([5, 5]);
          context.strokeStyle = 'rgba(255,255,255,.8)';
          context.lineWidth = 1;
          context.beginPath();
          context.moveTo(x, 0);
          context.lineTo(x, canvasHeight);
          context.stroke();
          context.setLineDash([]);
          context.fillStyle = 'rgba(0,0,0,.48)';
          context.fillRect(x - 22, canvasHeight / 2 - 9, 44, 18);
          context.fillStyle = '#fff';
          context.font = '11px sans-serif';
          context.textAlign = 'center';
          context.fillText(Math.round(x / scaleToCentimeters) + ' cm', x, canvasHeight / 2 + 4);
        }
        context.setLineDash([]);
        context.fillStyle = 'rgba(0,0,0,.48)';
        context.fillRect(canvasWidth / 2 - 26, 6, 52, 18);
        context.fillStyle = '#fff';
        context.font = '11px sans-serif';
        context.textAlign = 'center';
        context.fillText(width + ' cm', canvasWidth / 2, 19);
        context.save();
        context.translate(16, canvasHeight / 2);
        context.rotate(-Math.PI / 2);
        context.fillStyle = 'rgba(0,0,0,.48)';
        context.fillRect(-20, -9, 40, 18);
        context.fillStyle = '#fff';
        context.fillText(height + ' cm', 0, 4);
        context.restore();
      }

      context.strokeStyle = 'rgba(255,255,255,.9)';
      context.lineWidth = 1;
      context.strokeRect(.5, .5, canvasWidth - 1, canvasHeight - 1);
    }

    function cwcSetupPan() {
      if (canvas.dataset.panBound === '1') return;
      canvas.dataset.panBound = '1';
      canvas.style.cursor = 'grab';
      canvas.addEventListener('pointerdown', function (event) {
        if (!window.cwcImg) return;
        dragging = true;
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        panStartX = panX;
        panStartY = panY;
        canvas.style.cursor = 'grabbing';
        try {
          canvas.setPointerCapture(event.pointerId);
        } catch (error) {
          dragging = true;
        }
      });
      canvas.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        panX = panStartX + event.clientX - dragStartX;
        panY = panStartY + event.clientY - dragStartY;
        cwcDraw();
      });
      function endDrag() {
        dragging = false;
        canvas.style.cursor = 'grab';
      }
      canvas.addEventListener('pointerup', endDrag);
      canvas.addEventListener('pointercancel', endDrag);
      canvas.addEventListener('pointerleave', function () {
        if (dragging) endDrag();
      });
    }

    function updateCartCount(cart) {
      var count = cart.items.reduce(function (sum, item) {
        return sum + (item.properties && item.properties._area_priced_01 === 'true' ? 1 : item.quantity);
      }, 0);
      document.querySelectorAll('cart-count').forEach(function (element) {
        element.textContent = String(count);
      });
    }

    function cwcCart() {
      var dimensions = cwcDims();
      if (!dimensions.valid) {
        window.alert(root.dataset.invalidDimensions);
        return;
      }
      if (!window.cwcImg) {
        window.alert(root.dataset.imageRequired);
        return;
      }

      var currentPricing = pricing(dimensions);
      var comment = document.getElementById('cwc-note').value || '–';
      var formData = new FormData();
      formData.append('id', areaVariantId);
      formData.append('quantity', String(currentPricing.units));
      formData.append('properties[Bredd]', dimensions.w + ' cm');
      formData.append('properties[Höjd]', dimensions.h + ' cm');
      formData.append('properties[Yta]', currentPricing.measuredArea.toFixed(2) + ' m²');
      formData.append('properties[Debiterad yta]', currentPricing.billedArea.toFixed(1) + ' m²');
      formData.append('properties[Pris/m²]', formatMoney(pricePerSquareMeterCents));
      formData.append('properties[Totalt]', formatMoney(currentPricing.totalCents));
      formData.append('properties[Bild]', root.dataset.imageUploaded);
      formData.append('properties[Kommentar]', comment);
      formData.append('properties[_area_priced_01]', 'true');
      formData.append('properties[_billed_area]', currentPricing.billedArea.toFixed(1) + ' m²');

      var button = document.getElementById('cwc-atc');
      var label = document.getElementById('cwc-atc-label');
      button.disabled = true;
      label.textContent = root.dataset.adding;

      fetch('/cart/add.js', {method: 'POST', body: formData})
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || root.dataset.genericError);
            });
          }
          return fetch('/cart.js', {headers: {Accept: 'application/json'}});
        })
        .then(function (response) {
          if (!response.ok) throw new Error(root.dataset.genericError);
          return response.json();
        })
        .then(function (cart) {
          updateCartCount(cart);
          document.getElementById('cwc-added').style.display = 'block';
          label.textContent = root.dataset.added;
        })
        .catch(function (error) {
          button.disabled = false;
          label.textContent = root.dataset.addToCart;
          window.alert(error.message || root.dataset.connectionError);
        });
    }

    dropZone.addEventListener('click', function () {
      fileInput.click();
    });
    dropZone.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        fileInput.click();
      }
    });
    ['dragenter', 'dragover'].forEach(function (eventName) {
      dropZone.addEventListener(eventName, function (event) {
        event.preventDefault();
        event.stopPropagation();
        dropZone.classList.add('is-dragging');
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
      });
    });
    ['dragleave', 'drop'].forEach(function (eventName) {
      dropZone.addEventListener(eventName, function (event) {
        event.preventDefault();
        event.stopPropagation();
        dropZone.classList.remove('is-dragging');
      });
    });
    dropZone.addEventListener('drop', function (event) {
      var files = event.dataTransfer && event.dataTransfer.files;
      useFile(files && files[0]);
    });
    fileInput.addEventListener('change', cwcLoad);
    widthInput.addEventListener('input', cwcU);
    heightInput.addEventListener('input', cwcU);
    document.getElementById('bt-li').addEventListener('click', function () {
      cwcTog('lines', this);
    });
    document.getElementById('bt-gr').addEventListener('click', function () {
      cwcTog('gray', this);
    });
    document.getElementById('bt-fl').addEventListener('click', cwcFlip);
    document.getElementById('cwc-atc').addEventListener('click', cwcCart);
    window.addEventListener('resize', function () {
      window.clearTimeout(window.cwcResizeTimer);
      window.cwcResizeTimer = window.setTimeout(function () {
        if (window.cwcImg) cwcDraw();
      }, 200);
    });

    window.cwcDims = cwcDims;
    window.cwcU = cwcU;
    window.cwcDraw = cwcDraw;
    window.cwcCart = cwcCart;
    window.cwcLoad = cwcLoad;
    cwcU();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wallpaper-live-preview"] && !Shopify.designMode) return;
  try {
    (function () {
  function boot() {
    var root = document.getElementById('pw-configurator');
    if (!root || root.dataset.booted) return;
    root.dataset.booted = '2';
    var byId = function (id) { return document.getElementById(id); };
    var img = byId('pw-image'), preview = byId('pw-preview'), frame = byId('pw-crop-frame');
    var guides = byId('pw-guides'), shade = byId('pw-shade'), wi = byId('pw-width'), he = byId('pw-height');
    var coords = byId('pw-coordinates'), cropDetails = byId('pw-crop-details'), priceEl = byId('pw-price');
    var toggle = byId('pw-guides-toggle'), gray = byId('pw-gray'), flip = byId('pw-flip');
    var move = byId('pw-move'), reset = byId('pw-reset'), zoom = byId('pw-zoom'), zoomValue = byId('pw-zoom-value');
    var areaVariantId = root.dataset.areaVariantId || '';
    var unitPriceCents = parseInt(root.dataset.unitPriceCents, 10) || 3190;
    var state = {w: 0, h: 0, cx: 0.5, cy: 0.5, zoom: 1, gray: false, flipped: false, guides: true, editing: false, drag: null, ready: false};
    var geometry = null, scheduled = 0, disposed = false;
    var form = (root.closest('.product-info') || document).querySelector('form[is="product-form"],form[id^="product-form-"]');
    var locale = document.documentElement.lang || 'sv-SE';
    function number(value) { var n = parseFloat(String(value).replace(',', '.')); return Number.isFinite(n) && n > 0 ? n : 0; }
    function dimension(value) { var n = number(value), rounded = Math.round(n * 100) / 100; return Math.abs(n - rounded) < 0.00000001 ? rounded : 0; }
    function format(value, digits) { return value.toLocaleString(locale, {minimumFractionDigits: digits, maximumFractionDigits: digits}); }
    function centimeters(value) { return value.toLocaleString(locale, {minimumFractionDigits: 0, maximumFractionDigits: 2}) + ' cm'; }
    function fixed(value, digits) { return (Math.abs(value) < Math.pow(10, -digits) / 2 ? 0 : value).toFixed(digits); }
    function round(value) { return Number(fixed(value, 6)); }
    function clamp(value, low, high) { return Math.max(low, Math.min(high, value)); }
    function units() { return Math.ceil(state.w * state.h / 1000 - 0.000000001); }
    function hasCrop() {
      if (!state.ready || state.w <= 0 || state.h <= 0 || !Number.isSafeInteger(units()) || units() <= 0) return false;
      var image = sourceSize(), ratio = state.w / state.h, aspect = image.w / image.h;
      return Math.min(1, ratio / aspect) / state.zoom >= 0.000001 && Math.min(1, aspect / ratio) / state.zoom >= 0.000001;
    }
    function sourceSize() { return {w: number(root.dataset.imageWidth) || img.naturalWidth, h: number(root.dataset.imageHeight) || img.naturalHeight}; }
    function crop() {
      if (!hasCrop()) return null;
      var image = sourceSize(), ratio = state.w / state.h, aspect = image.w / image.h;
      var cw = Math.min(1, ratio / aspect) / state.zoom, ch = Math.min(1, aspect / ratio) / state.zoom;
      state.cx = clamp(state.cx, cw / 2, 1 - cw / 2); state.cy = clamp(state.cy, ch / 2, 1 - ch / 2);
      return {x: state.cx - cw / 2, y: state.cy - ch / 2, w: cw, h: ch};
    }
    function cropData(c) {
      var x = round(c.x), y = round(c.y);
      return {v: 2, image: root.dataset.imageId || '', x: x, y: y, w: round(round(c.x + c.w) - x), h: round(round(c.y + c.h) - y), flip: state.flipped, gray: state.gray};
    }
    function legacyOffsets(c) {
      if (!c) return {x: 0, y: 0};
      var centerX = state.flipped ? 1 - state.cx : state.cx;
      return {x: (0.5 - centerX) / c.w * state.w / 100, y: (0.5 - state.cy) / c.h * state.h / 100};
    }
    function cropText(c) { return 'X: ' + fixed(c.x * 100, 4) + ' %; Y: ' + fixed(c.y * 100, 4) + ' %; B: ' + fixed(c.w * 100, 4) + ' %; H: ' + fixed(c.h * 100, 4) + ' %'; }
    function properties() {
      var c = crop(), offset = legacyOffsets(c), qty = hasCrop() ? units() : 0;
      return {
        'Bredd': centimeters(state.w), 'Höjd': centimeters(state.h),
        'Yta': fixed(state.w * state.h / 10000, 2) + ' m²', 'Debiterad yta': fixed(qty / 10, 1) + ' m²',
        'X': fixed(offset.x, 2) + ' m', 'Y': fixed(offset.y, 2) + ' m',
        'Våder': (hasCrop() ? Math.ceil(state.w / 50) : 0) + ' st', 'Pris per m²': unitPriceCents / 10 + ' kr',
        'Vänd bild': state.flipped ? 'Ja' : 'Nej', 'Gråskala': state.gray ? 'Ja' : 'Nej',
        'Fototapet': root.dataset.productTitle || '', 'Bildutsnitt i originalbild (%)': c ? cropText(c) : '',
        '_area_priced_01': 'true', '_billed_area': fixed(qty / 10, 1) + ' m²',
        '_configured_title': root.dataset.productTitle || '', '_configured_url': root.dataset.productUrl || '',
        '_configured_handle': root.dataset.productHandle || '', '_configured_image': root.dataset.productImage || '',
        '_crop_version': '2', '_crop_data': c ? JSON.stringify(cropData(c)) : '', '_crop_image': root.dataset.sourceImage || ''
      };
    }
    function updateForm() {
      if (!form) return;
      var data = properties();
      Object.keys(data).forEach(function (key) {
        var input = form.querySelector('[data-pw="' + key + '"]');
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.dataset.pw = key; input.name = 'properties[' + key + ']'; form.appendChild(input); }
        input.value = data[key];
      });
      var variant = form.querySelector('input[name="id"]');
      if (variant) { variant.disabled = false; variant.value = areaVariantId; }
      var quantity = form.querySelector('input[name="quantity"]');
      if (!quantity) { quantity = document.createElement('input'); quantity.type = 'hidden'; quantity.name = 'quantity'; form.appendChild(quantity); }
      quantity.value = String(hasCrop() ? units() : 0);
      form.querySelectorAll('[type="submit"]').forEach(function (button) { button.disabled = !(hasCrop() && areaVariantId); });
    }
    function drawGuides(width) {
      guides.innerHTML = ''; guides.style.display = hasCrop() && state.guides ? 'block' : 'none';
      if (!hasCrop() || !state.guides) return;
      var panels = Math.ceil(state.w / 50), step = width * 50 / state.w;
      var fragment = document.createDocumentFragment();
      for (var i = 0; i < Math.min(panels, 500); i++) {
        if (i > 0) { var line = document.createElement('i'); line.style.left = i * step + 'px'; fragment.appendChild(line); }
        var label = document.createElement('b'); label.textContent = root.dataset.panelLabel + ' ' + (i + 1); label.style.left = i * step + 6 + 'px'; fragment.appendChild(label);
      }
      guides.appendChild(fragment);
    }
    function layout() {
      if (disposed) return;
      state.w = dimension(wi.value); state.h = dimension(he.value);
      state.ready = img.complete && img.naturalWidth > 0 && sourceSize().w > 0 && sourceSize().h > 0;
      var pw = preview.clientWidth, ph = preview.clientHeight, c = crop();
      move.disabled = reset.disabled = zoom.disabled = !hasCrop(); zoomValue.textContent = Math.round(state.zoom * 100) + ' %';
      img.style.filter = state.gray ? 'grayscale(1)' : ''; img.style.transform = 'scaleX(' + (state.flipped ? -1 : 1) + ')';
      if (!c && state.editing) setEditing(false);
      if (pw && ph && state.ready) {
        var image = sourceSize();
        if (!c) {
          var contain = Math.min(pw / image.w, ph / image.h);
          img.style.width = image.w * contain + 'px'; img.style.height = image.h * contain + 'px';
          img.style.left = (pw - image.w * contain) / 2 + 'px'; img.style.top = (ph - image.h * contain) / 2 + 'px';
          frame.style.display = shade.style.display = guides.style.display = 'none'; geometry = null;
        } else {
          var bw = Math.min(pw, ph * state.w / state.h), bh = bw * state.h / state.w;
          var left = (pw - bw) / 2, top = (ph - bh) / 2, rw = bw / c.w, rh = bh / c.h;
          var centerX = state.flipped ? 1 - state.cx : state.cx;
          frame.style.display = shade.style.display = 'block';
          frame.style.width = bw + 'px'; frame.style.height = bh + 'px'; frame.style.left = left + 'px'; frame.style.top = top + 'px';
          img.style.width = rw + 'px'; img.style.height = rh + 'px';
          img.style.left = left + bw / 2 - centerX * rw + 'px'; img.style.top = top + bh / 2 - state.cy * rh + 'px';
          shade.querySelector('.pw-shade-top').style.cssText = 'left:0;top:0;width:100%;height:' + top + 'px';
          shade.querySelector('.pw-shade-bottom').style.cssText = 'left:0;top:' + (top + bh) + 'px;width:100%;height:' + Math.max(0, ph - top - bh) + 'px';
          shade.querySelector('.pw-shade-left').style.cssText = 'left:0;top:' + top + 'px;width:' + left + 'px;height:' + bh + 'px';
          shade.querySelector('.pw-shade-right').style.cssText = 'left:' + (left + bw) + 'px;top:' + top + 'px;width:' + Math.max(0, pw - left - bw) + 'px;height:' + bh + 'px';
          geometry = {rw: rw, rh: rh}; drawGuides(bw);
        }
      }
      if (!c) {
        coords.textContent = state.ready ? root.dataset.pendingLabel : root.dataset.errorLabel; cropDetails.textContent = '';
        priceEl.textContent = root.dataset.priceLabel + ': ' + format(unitPriceCents / 10, 2) + ' kr/m²';
      } else {
        var offset = legacyOffsets(c);
        coords.textContent = 'X: ' + fixed(offset.x, 2) + ' m  Y: ' + fixed(offset.y, 2) + ' m  B: ' + fixed(state.w / 100, 2) + ' m  H: ' + fixed(state.h / 100, 2) + ' m';
        cropDetails.textContent = root.dataset.cropLabel + ': ' + cropText(c);
        priceEl.textContent = root.dataset.priceLabel + ': ' + format(units() * unitPriceCents / 100, 2) + ' kr (' + format(unitPriceCents / 10, 2) + ' kr/m²)';
      }
      updateForm();
    }
    function schedule() { if (!scheduled) scheduled = requestAnimationFrame(function () { scheduled = 0; layout(); }); }
    function setEditing(active) {
      state.editing = active; preview.classList.toggle('is-editing', active); move.setAttribute('aria-pressed', String(active));
      move.textContent = active ? root.dataset.doneLabel : root.dataset.moveLabel; state.drag = null;
    }
    function endDrag(event) { if (!event || !state.drag || event.pointerId === state.drag.id) state.drag = null; }
    function pointerDown(event) {
      if (!hasCrop() || !geometry || event.isPrimary === false || event.button > 0) return;
      if (event.pointerType !== 'mouse' && !state.editing) return;
      state.drag = {id: event.pointerId, x: event.clientX, y: event.clientY, cx: state.cx, cy: state.cy, rw: geometry.rw, rh: geometry.rh};
      preview.setPointerCapture(event.pointerId); event.preventDefault();
    }
    function pointerMove(event) {
      var drag = state.drag; if (!drag || event.pointerId !== drag.id) return;
      state.cx = drag.cx - (event.clientX - drag.x) / drag.rw * (state.flipped ? -1 : 1);
      state.cy = drag.cy - (event.clientY - drag.y) / drag.rh; crop(); schedule(); event.preventDefault();
    }
    preview.addEventListener('pointerdown', pointerDown); preview.addEventListener('pointermove', pointerMove);
    preview.addEventListener('pointerup', endDrag); preview.addEventListener('pointercancel', endDrag); preview.addEventListener('lostpointercapture', endDrag);
    preview.addEventListener('keydown', function (event) {
      var keys = {ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1]}, direction = keys[event.key], c = crop();
      if (!direction || !c) return;
      state.cx -= direction[0] * c.w * 0.01 * (state.flipped ? -1 : 1); state.cy -= direction[1] * c.h * 0.01;
      event.preventDefault(); layout();
    });
    wi.addEventListener('input', function () { endDrag(); layout(); }); he.addEventListener('input', function () { endDrag(); layout(); });
    zoom.addEventListener('input', function () { endDrag(); state.zoom = clamp(number(zoom.value) || 1, 1, 3); layout(); });
    move.addEventListener('click', function () { if (hasCrop()) setEditing(!state.editing); });
    reset.addEventListener('click', function () { state.cx = state.cy = 0.5; state.zoom = 1; zoom.value = '1'; setEditing(false); layout(); });
    toggle.addEventListener('click', function () { state.guides = !state.guides; toggle.setAttribute('aria-pressed', String(state.guides)); toggle.textContent = state.guides ? root.dataset.hideGuides : root.dataset.showGuides; layout(); });
    gray.addEventListener('click', function () { state.gray = !state.gray; gray.setAttribute('aria-pressed', String(state.gray)); gray.textContent = state.gray ? root.dataset.colorLabel : root.dataset.grayLabel; layout(); });
    flip.addEventListener('click', function () { endDrag(); state.flipped = !state.flipped; flip.setAttribute('aria-pressed', String(state.flipped)); layout(); });
    img.addEventListener('load', layout); img.addEventListener('error', layout);
    if (form) {
      form.addEventListener('submit', function (event) { layout(); if (!hasCrop() || !areaVariantId) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
      form.addEventListener('formdata', function (event) {
        state.w = dimension(wi.value); state.h = dimension(he.value); var data = properties();
        Object.keys(data).forEach(function (key) { event.formData.set('properties[' + key + ']', data[key]); });
        event.formData.set('id', areaVariantId); event.formData.set('quantity', String(hasCrop() ? units() : 0));
      });
    }
    function onResize() { endDrag(); schedule(); }
    window.addEventListener('resize', onResize);
    var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(onResize) : null; if (observer) observer.observe(preview);
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(root)) { disposed = true; window.removeEventListener('resize', onResize); if (observer) observer.disconnect(); if (scheduled) cancelAnimationFrame(scheduled); }
    });
    var env = Array.from(document.querySelectorAll('.pw-environment-thumb'));
    var lb = byId('pw-lightbox'), lbimg = byId('pw-lb-image'), close = document.querySelector('.pw-lb-close');
    var prev = document.querySelector('.pw-lb-prev'), next = document.querySelector('.pw-lb-next'), index = 0, returnFocus = null;
    function openLb() { if (!env.length) return; lbimg.src = env[index].dataset.src; lb.classList.add('open'); lb.setAttribute('aria-hidden', 'false'); close.focus(); }
    function closeLb() { lb.classList.remove('open'); lb.setAttribute('aria-hidden', 'true'); if (returnFocus) returnFocus.focus(); }
    env.forEach(function (button, i) { button.addEventListener('click', function () { returnFocus = button; index = i; openLb(); }); });
    close.addEventListener('click', closeLb); prev.addEventListener('click', function () { index = (index - 1 + env.length) % env.length; openLb(); });
    next.addEventListener('click', function () { index = (index + 1) % env.length; openLb(); });
    lb.addEventListener('click', function (event) { if (event.target === lb) closeLb(); });
    document.addEventListener('keydown', function (event) {
      if (!lb.classList.contains('open')) return;
      if (event.key === 'Escape') closeLb(); if (event.key === 'ArrowLeft') prev.click(); if (event.key === 'ArrowRight') next.click();
      if (event.key === 'Tab') {
        if (event.shiftKey && document.activeElement === close) { next.focus(); event.preventDefault(); }
        else if (!event.shiftKey && document.activeElement === next) { close.focus(); event.preventDefault(); }
      }
    });
    layout();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

})();
